const MiddleContentCampaign = ({ shortInfo }) => {
  if (!shortInfo || shortInfo.length === 0) return null; // don’t render empty wrapper
// console.log("Shortinfo",shortInfo)
  return (
    <div className="mt-6 sm:mt-8 w-full">
      {shortInfo?.map((section, index) => (
        <div
          key={index}
          className="w-full flex flex-col gap-4 sm:gap-6 py-3 sm:py-8 border-b border-gray-200 last:border-b-0"
          // data-aos="fade-up"
          // data-aos-delay={index * 100}
        >
          {/* THE IMAGES SECTION */}
          {section.infoImages?.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 w-full">
              {section.infoImages.slice(0, 2).map((img, i) => (
                <div
                  key={i}
                  className={`w-full overflow-hidden rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 ${
                    section.infoImages?.length === 1
                      ? "sm:col-span-2"
                      : "aspect-square"
                  }`}
                >
                  <img
                    src={img}
                    alt=""
                    className={`w-full ${
                      section.infoImages?.length === 1
                        ? "h-auto max-h-96"
                        : "h-full"
                    } object-cover rounded-lg transition-transform duration-300 hover:scale-105`}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          )}

          {/* TITLE */}
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-700 font-onest leading-tight">
            {section.heading}
          </h2>

          {/* DESCRIPTION */}
          <div className="  text-sm sm:text-base text-gray-700 tracking-wide leading-relaxed">
            <p className=" break-words whitespace-pre-line">
              {section.content}
            </p>
          </div>
          
        </div>
      ))}
    </div>
  );
};

export default MiddleContentCampaign;
